// FeesStructurePDF.jsx
import React from "react";
import {
  Document,
  Page,
  View,
  Text,
  Image,
  StyleSheet,
} from "@react-pdf/renderer";

// ================= STYLES =================
const styles = StyleSheet.create({
  page: {
    padding: 10,
    fontSize: 7,
    fontFamily: "Helvetica",
  },

  // ===== HEADER =====
  header: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 5,
  },
  logoContainer: {
    width: "10%",
    alignItems: "flex-start",
  },
  textContainer: {
    width: "90%",
    alignItems: "center",
  },
  logo: {
    width: 33,
    height: 33,
  },
  title: {
    fontSize: 12,
    fontWeight: "bold",
    textAlign: "center",
  },
  subtitle: {
    fontSize: 10,
    fontWeight: 600,
    marginTop: 1,
    textAlign: "center",
  },

  // ===== TABLE =====
  table: {
    display: "table",
    width: "auto",
    borderStyle: "solid",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
    marginTop: 2,
  },
  row: {
    flexDirection: "row",
  },
  thIndex: {
    width: "4.00%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 2,
    textAlign: "center",
    fontWeight: 600,
    backgroundColor: "#f5f5f5",
    fontSize: 8,
  },
  th: {
    width: "10.00%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 2,
    textAlign: "center",
    fontWeight: 600,
    backgroundColor: "#f5f5f5",
    fontSize: 8,
  },
  tdIndex: {
    width: "4.08%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 2,
    textAlign: "center",
    fontSize: 8,
  },
  td: {
    width: "9.09%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 2,
    textAlign: "center",
    fontSize: 8,
  },

  // ===== DESCRIPTION ROW =====
  descriptionRow: {
    backgroundColor: "#eeeeee",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 2,
    fontSize: 8,
    fontWeight: 600,
  },
});

// ================= COMPONENT =================
const FeesStructurePdf11 = ({ tableData }) => (
  <Document>
    <Page size="A4" orientation="landscape" style={styles.page}>
      {/* ===== HEADER ===== */}
      <View style={styles.header}>
        {/* Logo Left */}
        <View style={styles.logoContainer}>
          <Image src="/assets/images/jac.png" style={styles.logo} />
        </View>

        {/* Title + Subtitle Center */}
        <View style={styles.textContainer}>
          <Text style={styles.title}>JHARKHAND ACADEMIC COUNCIL, RANCHI</Text>
          <Text style={styles.subtitle}>
            Class XI - Fees Structure 2026 (Annual)
          </Text>
        </View>
      </View>

      {/* ===== TABLE ===== */}
      <View style={styles.table}>
        {/* Table Head */}
        <View style={styles.row}>
          <Text style={styles.thIndex}>#</Text>
          <Text style={styles.th}>Candidate Category</Text>
          <Text style={styles.th}>Gender</Text>
          <Text style={styles.th}>Board</Text>
          <Text style={styles.th}>ODPPM Fee</Text>
          <Text style={styles.th}>Registration Fee </Text>
          <Text style={styles.th}>Migration Fee</Text>
          <Text style={styles.th}>College Perm Fee</Text>
          <Text style={styles.th}>Examination Fee</Text>
          <Text style={styles.th}>Before Late Total Fee</Text>
          <Text style={styles.th}>Late Fine Reg</Text>
          <Text style={styles.th}>Late Fine Migration</Text>
          <Text style={styles.th}>Late Fine College Perm</Text>
          <Text style={styles.th}>After Late Total Fee</Text>
        </View>

        {/* Table Body */}
        {tableData && tableData.length > 0 ? (
          tableData.map((item, index) => (
            <React.Fragment key={index}>
              {/* ===== DESCRIPTION ROW ===== */}
              {item.description && (
                <View>
                  <Text style={styles.descriptionRow}>
                    Description: {item.description}
                  </Text>
                </View>
              )}

              {/* ===== DATA ROW ===== */}
              <View style={styles.row}>
                <Text style={styles.tdIndex}>{index + 1}</Text>
                <Text style={styles.td}>{item.category}</Text>
                <Text style={styles.td}>{item.gender}</Text>
                <Text style={styles.td}>{item.board}</Text>
                <Text style={styles.td}>{item.odppM_FEES}</Text>
                <Text style={styles.td}>{item.registratioN_FEES}</Text>
                <Text style={styles.td}>{item.migratioN_FEES}</Text>
                <Text style={styles.td}>{item.collegE_PERMISSION_FEES}</Text>
                <Text style={styles.td}>{item.clasS_11_EXAMINATION_FEES}</Text>
                <Text style={styles.td}>{item.beforE_LATE_TOTAL_FEES}</Text>
                <Text style={styles.td}>{item.latE_FINE_REGISTRATION}</Text>
                <Text style={styles.td}>{item.latE_FINE_MIGRATION}</Text>
                <Text style={styles.td}>
                  {item.latE_FINE_COLLEGE_PERMISSION}
                </Text>
                <Text style={styles.td}>{item.afteR_LATE_TOTAL_FEES}</Text>
              </View>
            </React.Fragment>
          ))
        ) : (
          <View style={styles.row}>
            <Text style={{ ...styles.td, width: "100%" }}>
              No data available
            </Text>
          </View>
        )}
      </View>
    </Page>
  </Document>
);

export default FeesStructurePdf11;
